import React from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

export default function SearchForm({ onSearch }) {
  const dispatch = useDispatch()

  const { register, handleSubmit } = useForm()

  const onSubmit = function (values) {
    onSearch(values)
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-row">
          <div className="col col-md-10">
            <input
              type="text"
              className="form-control dome-input"
              placeholder="Search company"
              {...register('query')}
            ></input>
          </div>
          <div className="col col-md-2">
            <button className="dome-btn dome-btn-base dome-btn-grey-stroke" type="submit">
              Search
            </button>
          </div>
        </div>
      </form>
    </>
  )
}
